export enum ServiceAuditDepth {
  FULL_DEPTH = "Full Depth",
  SUMMARY_ONLY = "Summary Only",
}

export enum ServiceStatus {
  ACCEPTED = "ACCEPTED",
  REJECTED = "REJECTED",
  UNREVIEWED = "UNREVIEWED",
  NO_REVIEW_REQUIRED = "NO_REVIEW_REQUIRED",
}

export type ErrorDetail = {
  unfavorable_errors_dollars: number;
  unfavorable_errors_count: number;
  favorable_errors_count: number;
  favorable_errors_dollars: number;
  logistics_charges: number;
};

export type GroupedServiceDetail = {
  status: ServiceStatus | null;
  audit_depth: ServiceAuditDepth;
  service_name: string;
} & ErrorDetail;

export type ServiceDetail = GroupedServiceDetail & {
  parent_service_name: string;
}

export enum ServiceDetailsKey {
  SUMMARY = "summary_services",
  DETAIL = "detail_services",
}

export enum PickAndPackTableHeader {
  INVOICE_LINES = "Invoice Lines",
  AUDIT_DEPTH = "Audit Depth",
  CHARGES = "Charges",
  ERRORS = "Errors",
}

export enum FreightTableHeader {
  CARRIER = "Carrier",
  SERVICE_LEVEL = "Service Level",
  BASE_FREIGHT = "Base Freight",
  ACCESSORIAL = "Accessorial",
  TOTAL = "Total",
  NUM_OF_ORDERS = "# of Orders",
  ERRORS = "Errors",
}

export enum ServiceSummaryTableHeader {
  SERVICES = "Services",
  AUDIT_DEPTH = "Audit Depth",
  CHARGES = "Charges",
  ERRORS = "Errors",
}

export type ServiceSortCriteria = {
  key: PickAndPackTableHeader | FreightTableHeader | ServiceSummaryTableHeader;
  order: "ascending" | "descending";
};

export enum ServiceTypeName {
  FREIGHT = "FREIGHT",
  PICK_N_PACK = "PICK_N_PACK",
  WHOLESALE_FREIGHT = "WHOLESALE_FREIGHT",
}

export const ServiceNameMapToDisplay = {
  [ServiceTypeName.FREIGHT]: "Parcel",
  [ServiceTypeName.PICK_N_PACK]: "Fulfillment",
  [ServiceTypeName.WHOLESALE_FREIGHT]: "Freight",
};

export const TypeChipTextColorMap = {
  [ServiceTypeName.FREIGHT]: "text-[#076180]",
  [ServiceTypeName.PICK_N_PACK]: "text-[#436512]",
  [ServiceTypeName.WHOLESALE_FREIGHT]: "text-[#3259A6]",
};

export const TypeChipBorderColorMap = {
  [ServiceTypeName.FREIGHT]: "border-[#89CED9]",
  [ServiceTypeName.PICK_N_PACK]: "border-[#B8C984]",
  [ServiceTypeName.WHOLESALE_FREIGHT]: "border-[#A6CBF2]",
};
